<template>
  <div>
    <b-row class="mx-0">
      <b-col>
        <h2>Manuelle Sperrgründe</h2>
      </b-col>
      <b-col>
        <b-button size="md" @click="create()" class="float-right">
          <span class="icon icon-plus"></span>
        </b-button>
      </b-col>
    </b-row>
   <b-table class="mt-3" :items="reasons" :fields="fields" striped hover>
      <template v-slot:cell(commentRequired)="data">
        <b-button v-if="data.item.commentRequired" @click="toggleCommentRequired(data.item)" variant="primary"><span class="icon icon-checkmark"/></b-button>
        <b-button v-else                           @click="toggleCommentRequired(data.item)"                  ><span class="icon icon-minus"/></b-button>
     </template>

      <template v-slot:cell(actions)="data">
        <b-button size="md" @click="nuke(data.item)" class="float-right">
          <span class="icon icon-bin"></span>
        </b-button>
      </template>
    </b-table>

       <b-modal
          v-model="modalEdit"
          size="md"
          centered
          hide-header
          no-close-on-esc
          no-close-on-backdrop
          dismissible
          @ok="save()"
        >
          <div class="modal-header">
            <h5 class="modal-title">Sperrgrund hinzufügen</h5>
          </div>
          <b-form-input
              list="blockReasons"
              size="md"
              placeholder="Grund"
              v-model="newReason"
          ></b-form-input>

        </b-modal>

  </div>
</template>
<script>
  export default
  {
		data() {
			return {
        reasons: null,
        modalEdit: false,
        newReason: "",
         fields: [
          { key: "reason", label: "Grund" },
          { key: "commentRequired", label: "Kommentar erforderlich" },
          { key: "actions", label: "" }
        ]
			}
		},
		methods: {
      create() {
        this.newReason = "";
        this.modalEdit = true;
      },
      save() {
        console.log("save called", this.newReason);

        axios.post('/blocker_manual_reason', { reason: this.newReason }).then( () => {
          axios.get("/blocker_manual_reason/all").then( response => {
            this.reasons = response.data;
          }).catch( error => {
            console.log("Netzwerkfehler.");
            console.error(error);
          });
        }).catch(error => {
          alert("Netzwerkfehler. Sperrgrund konnte nicht abgespeichert werden.");
        });
      },
      nuke(reason) {
        console.log("nuke called for reason" + JSON.stringify(reason));
        axios.delete('/blocker_manual_reason/' + reason.id).then( () => {
            axios.get("/blocker_manual_reason/all").then( response => {
              this.reasons = response.data;
            }).catch( error => {
                console.log("Netzwerkfehler.");
                console.error(error);
            });
        }).catch( error => {
          alert("Netzwerkfehler.");
        });

      },
      toggleCommentRequired(blockerManualReason) {
        axios.get(`/blocker_manual_reason/${blockerManualReason.id}/toggle_comment_required/`).then( () => {
          blockerManualReason.commentRequired = !blockerManualReason.commentRequired;
          if(blockerManualReason.commentRequired) {
          this.$bvToast.toast( `Sperrgrund »${blockerManualReason.reason}« benötigt jetzt ein Kommentar.`, {
                        title: "Manualler Sperrgrund",
                        autoHideDelay: 3000,
                        appendToast: false,
                        variant: 'success'
                    });
          }else{
            this.$bvToast.toast( `Sperrgrund »${blockerManualReason.reason}« benötigt jetzt keinen Kommentar.`, {
                title: "Manualler Sperrgrund",
                autoHideDelay: 3000,
                appendToast: false,
                variant: 'success'
            });
          }
        }).catch( error => {
          this.$bvToast.toast( "Speichervorgang ist fehlgeschlagen.", {
                        title: "Manueller Sperrgrund",
                        autoHideDelay: 8000,
                        appendToast: false,
                        variant: 'danger'
                    });
          console.error(error);
        });
      }
		},
		created() {
      axios.get("/blocker_manual_reason/all").then( response => {
        this.reasons = response.data;
      }).catch( error => {
        console.log("Netzwerkfehler.");
        console.error(error);
      });
		},
		mounted() {

		}
	}
</script>
